module.exports = __webpack_public_path__ + "img/35_27.96bc8e9b.png";